module.exports = __webpack_public_path__ + "static/media/square-root.d3eb2225.svg";